import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { catchError, EMPTY } from 'rxjs';
import { SlugContextService, SpacePublicInfo } from '../services/slug-context.service';

export const spaceResolver: ResolveFn<SpacePublicInfo> = (route) => {
  const slug = route.paramMap.get('slug') ?? '';
  const slugSvc = inject(SlugContextService);
  const router  = inject(Router);

  return slugSvc.resolve(slug).pipe(
    catchError(() => {
      // Slug no existe o club inactivo → landing
      router.navigate(['/']);
      return EMPTY;
    })
  );
};
